export const BLOG_CATEGORIES = [
  { value: "owner-grief", label: "Owner Grief" },
  { value: "aftercare-process", label: "Aftercare Process" },
  { value: "memorial-ideas", label: "Memorial Ideas" },
  { value: "pet-loss-support", label: "Pet Loss Support" },
  { value: "clinic-resources", label: "Clinic Resources" },
] as const;

export const BLOG_AUDIENCES = [
  { value: "pet-owners", label: "Pet Owners" },
  { value: "clinic-staff", label: "Clinic Staff" },
  { value: "vets", label: "Vets" },
  { value: "everyone", label: "Everyone" },
] as const;

export type BlogCategoryValue = (typeof BLOG_CATEGORIES)[number]["value"];
export type BlogAudienceValue = (typeof BLOG_AUDIENCES)[number]["value"];

export const isBlogCategory = (v: unknown): v is BlogCategoryValue =>
  typeof v === "string" && BLOG_CATEGORIES.some((c) => c.value === v);

export const isBlogAudience = (v: unknown): v is BlogAudienceValue =>
  typeof v === "string" && BLOG_AUDIENCES.some((a) => a.value === v);

export const blogCategoryLabel = (value: string): string =>
  BLOG_CATEGORIES.find((c) => c.value === value)?.label ?? value;

export const blogAudienceLabel = (value: string): string =>
  BLOG_AUDIENCES.find((a) => a.value === value)?.label ?? value;
